import {
  Product,
  ProductPageQuery,
  ProductVariant,
} from '@thg-commerce/enterprise-network/src/generated/graphql'

import { ProductRecommendation } from '../../ApolloProvider/resolvers/Query/Product/ProductPage'

export type ProductWithVipPrice = Omit<
  ProductPageQuery['product'] | Product | ProductRecommendation,
  'defaultVariant' | 'cheapestVariant' | 'variants'
> & {
  defaultVariant?: ProductVariant & {
    vipPrice?: {
      displayValue: string
      amount: string
    } | null
  }
  cheapestVariant?: ProductVariant & {
    vipPrice?: {
      displayValue: string
      amount: string
    } | null
  }
  variants: (ProductVariant & {
    vipPrice?: {
      displayValue: string
      amount: string
    } | null
  })[]
}

export const productPrice = (product: ProductWithVipPrice) => {
  const vipPrice = product?.defaultVariant?.vipPrice
    ? product?.defaultVariant?.vipPrice
    : product?.cheapestVariant?.vipPrice
    ? product?.cheapestVariant?.vipPrice
    : product?.variants?.[0]?.vipPrice
    ? product?.variants?.[0]?.vipPrice
    : null
  const price =
    product?.defaultVariant?.price ||
    product?.cheapestVariant?.price ||
    product?.variants[0].price

  if (!price) {
    return {
      price: '0.00',
      priceAmount: '0.00',
      rrp: null,
    }
  }

  return {
    price: vipPrice ? vipPrice.displayValue : price.price.displayValue,
    priceAmount: vipPrice ? vipPrice.amount : price.price.amount,
    rrp:
      price.rrp &&
      parseFloat(price.price.amount) < parseFloat(price.rrp?.amount)
        ? price.rrp.displayValue
        : null,
  }
}

export const priceRange = (product?: {
  cheapestVariant?: {
    price?: { price: { displayValue: string } } | null
    vipPrice?: { displayValue: string } | null
  } | null
  mostExpensiveVariant?: {
    price?: { price: { displayValue: string } } | null
    vipPrice?: { displayValue: string } | null
  } | null
}) => {
  if (!product || !product.cheapestVariant || !product.mostExpensiveVariant) {
    return {
      priceRange: null,
    }
  }

  const cheapestPrice = product.cheapestVariant?.vipPrice
    ? product.cheapestVariant?.vipPrice?.displayValue
    : product.cheapestVariant.price?.price.displayValue
  const mostExpensivePrice = product.mostExpensiveVariant?.vipPrice
    ? product.mostExpensiveVariant?.vipPrice?.displayValue
    : product.mostExpensiveVariant.price?.price.displayValue

  return cheapestPrice === mostExpensivePrice
    ? { priceRange: null }
    : {
        priceRange: `${cheapestPrice} - ${mostExpensivePrice}`,
      }
}
